import { useState, useEffect } from "react";

export const useSessionPersistedState = (key, defaultValue) => {
  const [state, setState] = useState(() => {
    try {
      const stored = sessionStorage.getItem(key);
      return stored ? JSON.parse(stored) : defaultValue;
    } catch (err) {
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(state));
    } catch (err) {
      console.error(`Failed to save ${key} to sessionStorage`, err);
    }
  }, [key, state]);

  return [state, setState];
};